var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 56,
    viewBox: "0 0 62 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1312_64685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6285 0.65847C12.4037 2.68598 3.4395 9.76137 0.809816 19.3421C-3.46284 34.8987 9.70886 54.3711 28.6007 55.9068C45.3748 57.2709 61.2041 44.0573 61.9721 29.6606C62.9355 11.5847 39.8921 -3.35478 21.6285 0.65847Z",
    fill: "#ECF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3004 15.6306C52.0491 15.3801 51.7931 15.1435 51.5278 14.9208C49.1867 12.9304 46.2452 11.8447 43.1314 11.8447C39.6686 11.8447 36.4106 13.1902 33.9625 15.6306C32.743 16.8462 31.7982 18.2567 31.1559 19.797C30.5043 21.3513 30.1646 23.0355 30.1646 24.7753C30.1646 28.2272 31.5143 31.4749 33.9625 33.9153C36.4106 36.3558 39.6686 37.7012 43.1314 37.7012C46.5942 37.7012 49.8523 36.3558 52.3004 33.9153C54.7486 31.4749 56.0983 28.2272 56.0983 24.7753C56.0983 21.3142 54.7486 18.0711 52.3004 15.6306ZM43.1314 35.5624C37.16 35.5624 32.3009 30.7186 32.3009 24.7707C32.3009 23.17 32.6499 21.6482 33.2829 20.2795C34.9957 16.5632 38.7657 13.9743 43.1314 13.9743C46.3103 13.9743 49.1727 15.343 51.1555 17.5236C52.9008 19.4398 53.962 21.9823 53.962 24.766C53.962 30.7186 49.1029 35.5624 43.1314 35.5624Z",
    fill: "#F9C067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5594 49.7927C21.6006 49.7927 20.707 49.1756 20.4091 48.2152L11.175 18.6702C10.9981 18.0995 11.0493 17.4918 11.3332 16.9582C11.6125 16.4293 12.0826 16.0349 12.6597 15.8586L43.4107 6.31032C44.5976 5.94379 45.8635 6.60261 46.2312 7.78571L55.4654 37.3307C55.8331 38.5138 55.1722 39.7758 53.9853 40.1423L23.2343 49.6906C23.0062 49.7602 22.7828 49.7927 22.5594 49.7927ZM44.0809 6.48662C43.8855 6.48662 43.69 6.51446 43.4945 6.57477L12.7388 16.1231C12.2362 16.2808 11.8219 16.6195 11.5799 17.0881C11.3332 17.5521 11.2867 18.0856 11.4449 18.5867L20.6791 48.1317C20.9444 48.9715 21.7216 49.5143 22.5641 49.5143C22.7596 49.5143 22.955 49.4865 23.1505 49.4261L53.9015 39.8778C54.4042 39.7201 54.8184 39.3814 55.0605 38.9128C55.3071 38.4488 55.3537 37.9153 55.1954 37.4142L45.9659 7.86922C45.7006 7.02482 44.9187 6.48662 44.0809 6.48662Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.922 42.9347L18.1983 48.5068C17.0487 48.711 15.9549 47.9454 15.7501 46.7995L10.3651 16.3219C10.1603 15.1759 10.9283 14.0856 12.0779 13.8815L43.8016 8.30932C44.9512 8.10518 46.045 8.87071 46.2498 10.0167L51.6348 40.4942C51.8396 41.6402 51.0717 42.7352 49.922 42.9347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2111 13.626L15.9735 17.3562C15.1404 17.5047 14.5819 18.2934 14.7308 19.1286C14.8798 19.959 15.671 20.5158 16.5088 20.3673L37.7464 16.6371L37.2111 13.626Z",
    fill: "#0054B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3302 12.9029L38.0349 13.4828L38.5655 16.4939L41.8608 15.914C42.6939 15.7655 43.2524 14.9768 43.1035 14.1416C42.9592 13.3112 42.1633 12.7544 41.3302 12.9029Z",
    fill: "#0054B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2558 14.3736L39.9666 13.905C39.8875 13.8771 39.8083 13.9421 39.8223 14.0256L40.0597 15.3711C40.0736 15.4546 40.1714 15.4871 40.2365 15.436L41.2884 14.5545C41.3536 14.5035 41.3349 14.4014 41.2558 14.3736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4757 22.0547L21.6667 22.7236L25.3886 43.7825L29.1976 43.1136L25.4757 22.0547Z",
    fill: "#0054B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4165 23.0899L15.6075 23.7588L19.3294 44.8177L23.1383 44.1487L19.4165 23.0899Z",
    fill: "#0054B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.521 20.8545L27.712 21.5234L31.4541 42.6966L35.263 42.0276L31.521 20.8545Z",
    fill: "#0054B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5755 19.7647L33.7666 20.4336L37.5095 41.6112L41.3184 40.9423L37.5755 19.7647Z",
    fill: "#E4ECF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6299 18.6699L39.8209 19.3389L43.5646 40.5212L47.3736 39.8522L43.6299 18.6699Z",
    fill: "#E4ECF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1312_64685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.fa98b8bff4937fd53cadd1d048043449.svg";
export { ForwardRef as ReactComponent };